import { render, staticRenderFns } from "./BlocksList.vue?vue&type=template&id=f2c746ce&scoped=true&"
import script from "./BlocksList.vue?vue&type=script&lang=js&"
export * from "./BlocksList.vue?vue&type=script&lang=js&"
import style0 from "./BlocksList.vue?vue&type=style&index=0&id=f2c746ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c746ce",
  null
  
)

export default component.exports